// src/pages/PaymentSuccess.js
// Stripe redirects here after a successful payment (return_url).
// Calls markJobPaid to update the job doc in case the webhook hasn't fired yet.
// markJobPaid finds the job by PaymentIntent id and retrieves the PI on the carrier's
// connected account (direct charges).
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';
import BrandName from '../components/BrandName';
import './PaymentSuccess.css';

const functions = getFunctions(app);

const PaymentSuccess = () => {
  const [searchParams]  = useSearchParams();
  const navigate        = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    document.title = 'Payment Successful — The WasteGame';
    const paymentIntentId = searchParams.get('payment_intent');
    if (!paymentIntentId) {
      setStatus('success'); // navigated here manually, still show success
      return;
    }

    const markJobPaid = httpsCallable(functions, 'markJobPaid');
    markJobPaid({ paymentIntentId })
      .then(() => setStatus('success'))
      .catch(err => {
        console.error('[PaymentSuccess] markJobPaid error:', err);
        // Still show success — payment went through, just the sync failed
        setStatus('success');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="ps-page">
      <div className="ps-card">
        <div className="ps-logo"><BrandName /></div>
        {status === 'loading' ? (
          <p className="ps-loading">Confirming payment…</p>
        ) : (
          <>
            <div className="ps-tick">✅</div>
            <h2 className="ps-title">Payment Successful!</h2>
            <p className="ps-sub">Thank you. Your payment has been received and the carrier will be paid shortly.</p>
            <button
              className="btn btn-primary ps-btn"
              onClick={() => navigate('/customer-dashboard')}
            >
              Back to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
